var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "222px",
    viewBox: "0 0 216 222",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pack-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.746711%",
    y1: "0%",
    x2: "-1.11022302e-14%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05324",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68A21",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97E1BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EC086",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 48.5,
    cy: 48.5,
    r: 48.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-26.3%",
    y: "-23.2%",
    width: "152.6%",
    height: "152.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.296028191 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.6932342%",
    y1: "0%",
    x2: "63.9157816%",
    y2: "68.9185989%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.5%",
    y: "-18.5%",
    width: "136.9%",
    height: "136.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "79.7846575%",
    y1: "15.2164704%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83BFFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8BF7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Branding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-145.000000, -2361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pack-2",
    transform: "translate(161.000000, 2374.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,0 C168.429045,0 200,39.2500126 200,100 C200,160.749987 170.303194,200 100,200 C29.6968058,200 0,163.066536 0,100 C0,36.9334635 31.5709552,0 100,0 Z",
    id: "Rectangle-Copy-11",
    fill: "url(#linearGradient-1)",
    transform: "translate(100.000000, 100.000000) scale(1, -1) translate(-100.000000, -100.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plant-(1)",
    transform: "translate(26.000000, 28.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9804086,4.04202961 C38.5344881,4.04202961 30.8406753,4.49770027 26.9088994,8.42736878 C25.2066242,10.129644 24.3565881,12.9046659 24.5772872,16.0456036 C24.6059282,16.460468 24.881802,16.8139312 25.2781789,16.9447797 C25.6725443,17.0735208 26.1058002,16.9529218 26.3755435,16.6362417 C28.5621304,14.0634315 31.2799659,12.0015625 34.4596985,10.5077252 C34.7294417,10.3789841 35.0482291,10.3687346 35.3383755,10.470942 C35.5938462,10.5628999 35.7940462,10.7365663 35.8982652,10.9593727 C36.1148452,11.4171507 36.0453979,12.019954 35.3261145,12.3591447 C35.2852124,12.3795478 35.2484292,12.4061773 35.2076229,12.4245689 C35.1933502,12.4306994 35.1769702,12.4286878 35.1647092,12.4348184 C27.3298943,16.1172542 23.477911,22.5420476 21.7286032,29.1486496 C20.4534533,20.8765556 17.7601399,16.0068089 15.2159707,13.0172185 C13.3748007,10.6304315 11.5641876,9.36543537 10.5179746,8.65027095 C10.3238093,8.51741092 9.73738599,8.11691501 9.49417645,7.87370546 C9.09569212,7.47522114 9.09569212,6.82739674 9.49417645,6.42891241 C9.89266077,6.03243967 10.5424968,6.03243967 10.9859064,6.47383769 C11.0942443,6.56991456 11.2679106,6.69252512 11.4886097,6.8396578 L11.6705139,6.96226836 C13.1499828,7.97581707 15.9046973,9.8578892 18.3486706,13.9101683 C18.567358,14.2718694 18.9903645,14.4660348 19.4011099,14.3883495 C19.8179858,14.3147831 20.1449153,13.9939841 20.2267196,13.5791198 C20.7600755,10.8551537 20.5209849,6.81302831 18.0912842,4.38332761 C14.1596041,0.455670674 6.46579136,0 1.0218824,0 C0.457778028,0 0,0.457682254 0,1.02169084 C0,6.46761137 0.455670659,14.1614241 4.38533917,18.0932 C6.02420175,19.7320626 8.5520867,20.467726 11.0634959,20.467726 C13.1131038,20.467726 15.1219055,19.9547732 16.660668,19.0658466 C18.7593202,23.4144026 20.4350617,29.9107508 20.4350617,39.8483369 C20.4350617,40.4123455 20.8928398,40.8701235 21.4568484,40.8701235 C22.0208569,40.8701235 22.478635,40.4123455 22.478635,39.8483369 C22.478635,34.3043279 23.4288668,27.6505975 26.9620626,22.1740244 C28.3782146,23.5575121 30.8161532,24.4341777 33.5176087,24.5158861 C33.6524803,24.520005 33.7853404,24.5220166 33.9181046,24.5220166 C36.6625696,24.5220166 39.0881514,23.6617311 40.6146529,22.1331222 C44.546333,18.2014422 45,10.5076294 45,5.06161307 C45.0021952,4.49770027 44.5464288,4.04202961 43.9804086,4.04202961 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(105.365107, 30.181303)",
    strokeLinecap: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.84217094e-14,1.70530257e-13 C19.9477408,0.14844995 34.3850282,9.58816422 43.3118621,28.3191428 C52.238696,47.0501214 49.8017473,68.2998507 36.0010162,92.0683308",
    id: "Path-8",
    stroke: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6348927,77.8186969 L32.7536145,103.427922 C33.2260847,104.426344 34.418478,104.852711 35.4168997,104.380241 C35.6023916,104.292463 35.7732693,104.17666 35.9235322,104.036899 L54.7693332,86.5081425 L54.7693332,86.5081425",
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    transform: "translate(37.702113, 91.858380) rotate(30.000000) translate(-37.702113, -91.858380) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    filter: "url(#filter-6)",
    transform: "translate(62.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-7)",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "credit-card-fill",
    transform: "translate(20.000000, 23.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.125 C0,1.39911016 1.39911016,0 3.125,0 L21.875,0 C23.6008898,0 25,1.39911016 25,3.125 L25,4.6875 L0,4.6875 L0,3.125 Z M0,7.8125 L0,15.625 C0,17.3508898 1.39911016,18.75 3.125,18.75 L21.875,18.75 C23.6008898,18.75 25,17.3508898 25,15.625 L25,7.8125 L0,7.8125 Z M4.6875,10.9375 L6.25,10.9375 C7.11294492,10.9375 7.8125,11.6370551 7.8125,12.5 L7.8125,14.0625 C7.8125,14.9254449 7.11294492,15.625 6.25,15.625 L4.6875,15.625 C3.82455508,15.625 3.125,14.9254449 3.125,14.0625 L3.125,12.5 C3.125,11.6370551 3.82455508,10.9375 4.6875,10.9375 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(111.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.72,11.62 C22.72,11.9 22.86,10.84 23.3,10.14 C23.6534622,9.09065898 24.790659,8.52653776 25.84,8.88 C26.889341,9.23346224 27.4534622,10.370659 27.1,11.42 C27.1,12.72 27.1,12.66 27.1,13.54 C27.1,14.42 27.1,15.2 27.1,15.94 C27.0278752,17.1104336 26.8674184,18.2737448 26.62,19.42 C26.2991332,20.43714 25.8416193,21.4059931 25.26,22.3 C24.2888956,23.3799283 23.4865089,24.6003653 22.88,25.92 C22.7317699,26.5759751 22.6646013,27.247662 22.68,27.92 C22.6782297,28.5412511 22.7589346,29.1599884 22.92,29.76 C22.1022627,29.8461485 21.2777373,29.8461485 20.46,29.76 C19.68,29.64 18.72,28.08 18.46,27.6 C18.3313558,27.3422653 18.0680565,27.1794113 17.78,27.1794113 C17.4919435,27.1794113 17.2286442,27.3422653 17.1,27.6 C16.66,28.36 15.68,29.74 15.1,29.82 C13.76,29.98 10.98,29.82 8.82,29.82 C8.82,29.82 9.18,27.82 8.36,27.1 C7.54,26.38 6.7,25.54 6.08,24.98 L4.42,23.14 C3.24861368,22.0539901 2.39185415,20.6721199 1.94,19.14 C1.52,17.26 1.56,16.34 1.94,15.6 C2.32757864,14.9724092 2.93278483,14.5096045 3.64,14.3 C4.22763146,14.1950836 4.83204735,14.2362938 5.4,14.42 C5.79307704,14.5834152 6.1325546,14.8536117 6.38,15.2 C6.84,15.82 6.98,16.12 6.8,15.44 C6.62,14.76 6.4,13.74 5.98,12.34 C5.56,10.94 5.3,10.62 5.04,9.88 C4.78,9.14 4.44,8.44 4.04,7.52 C3.67452723,6.57978757 3.36727951,5.61796861 3.12,4.64 C2.94232684,3.82148667 3.13238455,2.96622697 3.64,2.3 C4.35771373,1.59964253 5.39336358,1.33311499 6.36,1.6 C7.11796657,1.93012625 7.75908366,2.48065071 8.2,3.18 C8.79007243,4.12333654 9.27305971,5.12956003 9.64,6.18 C10.3014133,7.89628307 10.7709355,9.68046726 11.04,11.5 C11.0015037,10.4258806 11.095546,9.35111126 11.32,8.3 C11.5422985,7.65162935 12.0516293,7.14229851 12.7,6.92 C13.2956183,6.73725039 13.925691,6.69615869 14.54,6.8 C15.1600734,6.92963181 15.7093277,7.28629049 16.08,7.8 C16.5418143,8.96724964 16.7989136,10.2053861 16.84,11.46 C16.8673989,10.3921452 17.0218187,9.33134847 17.3,8.3 C17.6353952,7.83029837 18.1229767,7.49111126 18.68,7.34 C19.3413046,7.22042193 20.0186954,7.22042193 20.68,7.34 C21.2221889,7.52126168 21.696482,7.86303171 22.04,8.32 C22.4644741,9.38040058 22.7208915,10.5005398 22.8,11.64",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.72,11.62 C22.72,11.9 22.86,10.84 23.3,10.14 C23.6534622,9.09065898 24.790659,8.52653776 25.84,8.88 C26.889341,9.23346224 27.4534622,10.370659 27.1,11.42 C27.1,12.72 27.1,12.66 27.1,13.54 C27.1,14.42 27.1,15.2 27.1,15.94 C27.0278752,17.1104336 26.8674184,18.2737448 26.62,19.42 C26.2991332,20.43714 25.8416193,21.4059931 25.26,22.3 C24.2888956,23.3799283 23.4865089,24.6003653 22.88,25.92 C22.7317699,26.5759751 22.6646013,27.247662 22.68,27.92 C22.6782297,28.5412511 22.7589346,29.1599884 22.92,29.76 C22.1022627,29.8461485 21.2777373,29.8461485 20.46,29.76 C19.68,29.64 18.72,28.08 18.46,27.6 C18.3313558,27.3422653 18.0680565,27.1794113 17.78,27.1794113 C17.4919435,27.1794113 17.2286442,27.3422653 17.1,27.6 C16.66,28.36 15.68,29.74 15.1,29.82 C13.76,29.98 10.98,29.82 8.82,29.82 C8.82,29.82 9.18,27.82 8.36,27.1 C7.54,26.38 6.7,25.54 6.08,24.98 L4.42,23.14 C3.24861368,22.0539901 2.39185415,20.6721199 1.94,19.14 C1.52,17.26 1.56,16.34 1.94,15.6 C2.32757864,14.9724092 2.93278483,14.5096045 3.64,14.3 C4.22763146,14.1950836 4.83204735,14.2362938 5.4,14.42 C5.79307704,14.5834152 6.1325546,14.8536117 6.38,15.2 C6.84,15.82 6.98,16.12 6.8,15.44 C6.62,14.76 6.4,13.74 5.98,12.34 C5.56,10.94 5.3,10.62 5.04,9.88 C4.78,9.14 4.44,8.44 4.04,7.52 C3.67452723,6.57978757 3.36727951,5.61796861 3.12,4.64 C2.94232684,3.82148667 3.13238455,2.96622697 3.64,2.3 C4.35771373,1.59964253 5.39336358,1.33311499 6.36,1.6 C7.11796657,1.93012625 7.75908366,2.48065071 8.2,3.18 C8.79007243,4.12333654 9.27305971,5.12956003 9.64,6.18 C10.3014133,7.89628307 10.7709355,9.68046726 11.04,11.5 C11.0015037,10.4258806 11.095546,9.35111126 11.32,8.3 C11.5422985,7.65162935 12.0516293,7.14229851 12.7,6.92 C13.2956183,6.73725039 13.925691,6.69615869 14.54,6.8 C15.1600734,6.92963181 15.7093277,7.28629049 16.08,7.8 C16.5418143,8.96724964 16.7989136,10.2053861 16.84,11.46 C16.8673989,10.3921452 17.0218187,9.33134847 17.3,8.3 C17.6353952,7.83029837 18.1229767,7.49111126 18.68,7.34 C19.3413046,7.22042193 20.0186954,7.22042193 20.68,7.34 C21.2221889,7.52126168 21.696482,7.86303171 22.04,8.32 C22.4350954,9.37846423 22.6644619,10.4915664 22.72,11.62 Z",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,23.6517811 L21.5,16.7482185 C21.5,16.3349888 21.1642136,16 20.75,16 C20.3357864,16 20,16.3349888 20,16.7482185 L20,23.6517811 C20,24.0650108 20.3357864,24.3999996 20.75,24.3999996 C21.1642136,24.3999996 21.5,24.0650108 21.5,23.6517811 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.519997,23.651403 L17.5,16.7442944 C17.4988033,16.3320457 17.1620505,15.9988151 16.7478387,16 C16.3336269,16.0011912 15.9988095,16.3363479 16,16.7485966 L16.0200032,23.6557052 C16.0211969,24.067954 16.3579496,24.4011845 16.7721614,24.3999996 C17.1863733,24.3988084 17.5211906,24.0636517 17.519997,23.651403 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16.7598133 L12.0400131,23.6490212 C12.0424354,24.0662075 12.3801797,24.4024261 12.7943862,24.3999996 C13.2085926,24.3975467 13.5424097,24.0573726 13.5399875,23.6401863 L13.4999875,16.7509784 C13.4975652,16.3337921 13.1598209,15.9975735 12.7456144,16 C12.3314079,16.0024529 11.9975908,16.342627 12,16.7598133 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack2);
export default __webpack_public_path__ + "static/media/pack-2.429ff43653380d7d1164b76d77eb9b7f.svg";
export { ForwardRef as ReactComponent };